import ExcelJS from "exceljs";
import { isEmpty } from "lodash";
import type { ChangeEventHandler, FC, MouseEventHandler } from "react";
import { cloneElement, useEffect, useRef, useState } from "react";
import { ExcelTemplateType, getTemplate } from "./excel-template";
import { useExcelTemplate } from "./hooks/useExcelTemplate";

interface Props {
  accept?: string;
  template: ExcelTemplateType;
  disabled?: boolean;
  onChange?: (rows: unknown[], file: File) => void;
  onClick?: MouseEventHandler<HTMLInputElement>;
  children: JSX.Element;
}

const EXCEL_FILE = ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel";

const UploadExcelFile: FC<Props> = (props) => {
  const { accept = EXCEL_FILE, template, disabled, onChange = () => {}, children } = props;
  const { importFile } = useExcelTemplate();
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [file, setFile] = useState<File | undefined>(undefined);
  const [loadFile, setLoadFile] = useState(false);
  // const onChangeRef = useRef(onChange);

  // useEffect(() => {
  //   onChangeRef.current = onChange;
  // }, [onChange]);

  useEffect(() => {
    if (!file) return;

    const reader = new FileReader();

    const handleUpload = async (evt: ProgressEvent<FileReader>) => {
      setLoadFile(true);
      try {
        /**
         * Handle import file & validate fields
         */
        const data = await importFile({
          buffer: evt.target?.result as ExcelJS.Buffer,
          template: getTemplate(template),
        });

        if (!data || isEmpty(data)) {
          return;
        }

        /**
         * bindingData
         */
        // onChangeRef.current?.(data);
        onChange(data, file);

        setFile(undefined);
        clearInputRefValue();
      } catch (error) {
        console.error(error);
      } finally {
        setLoadFile(false);
      }
    };

    reader.readAsArrayBuffer(file);
    reader.addEventListener("load", handleUpload);

    return () => {
      reader.removeEventListener("load", handleUpload);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file, importFile, template]);

  const clearInputRefValue = () => {
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  const handleUploadClick = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };
  const onInputChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    setFile(file);
  };

  const isDisabled = loadFile || disabled;

  return (
    <label style={{ margin: 0 }} className="btnUpload" aria-disabled={isDisabled}>
      {cloneElement(children, {
        onClick: handleUploadClick,
        disabled: isDisabled,
      })}
      <input ref={inputRef} hidden type="file" accept={accept} multiple={false} onChange={onInputChange} />
    </label>
  );
};

export default UploadExcelFile;
